import { useEffect, useRef } from 'react'

import useReduxSelector from '../hooks/useReduxSelector'
import { identifyIntercomUser } from '../utils/intercom'
import { configureRollbarPerson } from '../utils/rollbar'

// Distinguishes "not yet handled" from an anonymous (undefined) user id.
const NOT_IDENTIFIED = Symbol('notIdentified')

// Once the currentUser fetch settles, hand the signed-in user's identity to the
// third-party SDKs the server snippets boot anonymously (to keep the page
// edge-cacheable): Intercom and Rollbar. Re-runs if the user signs in without a
// full reload; anonymous viewers are left unidentified.
export const useIdentifyUserToServices = (): void => {
  const user = useReduxSelector((state) => state.auth.currentUser)
  const authFetched = useReduxSelector((state) => state.auth.fetched)
  const identifiedAs = useRef<typeof NOT_IDENTIFIED | number | undefined>(
    NOT_IDENTIFIED,
  )

  useEffect(() => {
    const userId = user?.id
    if (!authFetched || identifiedAs.current === userId) return

    identifiedAs.current = userId
    // No un-identify on sign-out: logging out navigates to /users/sign_out (a
    // full reload), which re-boots both SDKs anonymously.
    if (userId == null) return

    identifyIntercomUser(user)
    configureRollbarPerson(userId)
  }, [authFetched, user])
}
